import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "@/lib/toast";
import { Link } from "react-router-dom";
import { Mail, ArrowRight, CheckCircle2 } from "lucide-react";
import { emailError } from "@/lib/validate";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    const m = emailError(email, { required: true });
    setErr(m);
    if (m) return;
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email: email.trim() }); setSent(true); }
    catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="jali min-h-[70vh] flex items-start justify-center px-4 py-12 sm:py-20">
      <div className="w-full max-w-md card-heritage p-6 sm:p-9">
        <h1 className="font-display text-[34px] sm:text-4xl text-[color:var(--maroon)] leading-tight">Reset your password</h1>
        {sent ? (
          <p className="mt-4 text-neutral-700 flex gap-2"><CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5"/> If that email is registered, a reset link has been sent. Check your inbox.</p>
        ) : (
          <form onSubmit={submit} noValidate className="mt-6 space-y-4">
            <label className="block">
              <span className="label">Registered email</span>
              <span className="relative block">
                <Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[color:var(--gold)]"/>
                <input type="email" inputMode="email" autoComplete="email" placeholder="you@example.com" value={email} onChange={(e) => { setEmail(e.target.value); if (err) setErr(""); }} className={`input !pl-11 ${err ? "invalid" : ""}`} data-testid="forgot-email"/>
              </span>
              {err && <span className="field-error" role="alert">{err}</span>}
            </label>
            <button disabled={busy} className="btn-wine w-full !py-3.5">{busy ? "Sending…" : <>Send reset link <ArrowRight className="w-4 h-4"/></>}</button>
          </form>
        )}
        <div className="mt-6 text-sm"><Link to="/login" className="text-[color:var(--maroon)] font-semibold underline underline-offset-4">Back to sign in</Link></div>
      </div>
    </div>
  );
}
